export const styles = {
  root: {
    width: "100%",
    height: "100%",
    position: "relative",
    borderRadius: "2px",
    left: "50%",
    transform: "translateX(-50%)",

    "& img": {
      objectFit: "contain",
    },
  },
};
